<template>
  <backbar-page-layout
    v-if="canPerform('authcore.auditLogs.list')"
    back-title="title.user_details"
    title="title.logs"
    :user-id="id"
    :loading="isLoadingStatus"
  >
    <template #alert>
      <b-row>
        <b-col>
          <!-- TODO: Put the loading / error messages into their corresponding places -->
          <b-alert
            variant="danger"
            show
            v-if="error !== undefined"
          >
            <i18n path="status.error.general" tag="div">
              <span place="message">{{ error.message }}</span>
            </i18n>
          </b-alert>
        </b-col>
      </b-row>
    </template>
    <b-container class="mt-4">
      <log-table
        class="mt-5"
        :loading="loading"
        :log-data="logs"
        :total-items="logs.length"
        :rows-per-page="10"
      />
    </b-container>
  </backbar-page-layout>
  <b-alert v-else variant="danger" show>
    <i18n path="status.error.not_authorized" tag="div">
      <span place="page">{{ $t('general.log_list') }}</span>
    </i18n>
  </b-alert>
</template>

<script>
import { mapState } from 'vuex'

import BackbarPageLayout from '@/components/BackbarPageLayout.vue'
import LogTable from '@/components/LogTable.vue'

export default {
  name: 'UserLogs',
  components: {
    BackbarPageLayout,
    LogTable
  },

  props: {
    id: {
      type: Number,
      required: true
    }
  },

  computed: {
    ...mapState('client', [
      'authenticated'
    ]),
    ...mapState('management/userDetails/logsList', [
      'logs',
      'loading',
      'error'
    ]),
    isLoadingStatus () {
      return !this.authenticated || this.loading
    }
  }
}
</script>
